'use client';

import Icon from '@ant-design/icons';
import type { ReactNode } from 'react';

import CloseSvg from '@/components/Icon/svgs/close.svg';

import { COMMON_MODAL_ICONS } from './constants';
import styles from './index.less';

export interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  content?: ReactNode;
  footer?: ReactNode;
  icon?: string;
  closable?: boolean;
  maskClosable?: boolean;
  className?: string;
}

export default function CommonModal(props: CommonModalProps) {
  const {
    open,
    onClose,
    content,
    footer,
    icon = COMMON_MODAL_ICONS.CHAHUA,
    closable = true,
    maskClosable = true,
    className
  } = props;

  if (!open) return null;

  const handleMaskClick = () => {
    if (maskClosable) {
      onClose();
    }
  };

  return (
    <>
      {/* Mask */}
      <div className={styles.mask} onClick={handleMaskClick} />

      {/* Modal Card */}
      <div className={`${styles.modalCard} ${className || ''}`}>
        {/* Close Button */}
        {closable && (
          <div className={styles.closeButton} onClick={onClose}>
            <Icon className={styles.closeIcon} component={CloseSvg} />
          </div>
        )}

        {/* Icon */}
        {icon && <img alt="icon" className={styles.iconContainer} src={icon} />}

        {/* Content */}
        {content && <div className={styles.content}>{content}</div>}

        {/* Footer */}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </>
  );
}
